import React, { useMemo, useState } from 'react'
// import { Guide } from 'component'
import ToolSelect from 'baseComponent/toolSelect'
import util from 'meinian-package/src/utils/util'
import { renderDownloadModal } from 'component/batch/download'
import DownloadCenter from 'component/download'
import request from 'meinian-package/src/utils/request'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import { clearBatch } from 'component/batch/base'
import { BATCH_TYPE } from './batchType'

export const useBatch = () => {
  const [batchValue, setBatchValue] = useState(null)
  const [batchAll, setBatchAll] = useState([])

  const cancelBatch = () => {
    clearBatch()
    setBatchValue(null)
  }
  return {
    batchAll,
    batchValue,
    setBatchAll,
    setBatchValue,
    cancelBatch
  }
}

export const BatchDownload = ({ inspirationId, onChange, style }) => {
  const options = [
    { label: '全部下载', value: 1, },
    { label: '批量下载', value: BATCH_TYPE.download, }
  ]
  if (teamHasAuth('meinian_download_all_blog')) {
    options.unshift({ label: '全部下载', value: 1, })
  }
  return <ToolSelect
    displayTextClassName="fill-white-bg"
    style={style}
    label="下载"
    labelIcon="m-xiazai"
    onChange={(val) => {
      if (val === 1) {
        renderDownloadModal({
          hiddenFolderLevel: true,
          onOk: async (type, keepStruct) => {
            await request.get(`/ins/inspiration/download-all-blog?inspirationId=${inspirationId}&type=${type}&keepStruct=${keepStruct}`)
            util.track('mn-image-download', {
              module1: '全部下载',
              module2: type === 1 ? '全部图片' : '首图',
            })
            DownloadCenter.start({ type: 1 })
          }
        })
      } else {
        onChange(val)
      }
    }}
    options={[
      { label: '全部下载', value: 1, },
      { label: '批量下载', value: BATCH_TYPE.download, }
    ]}
  />
}

export const BatchExport = ({ inspirationId, onChange, auth, style }) => { // 批量导出
  const options = [
    { label: '批量导出', value: BATCH_TYPE.export, }
  ]
  if (auth.includes('F02') || auth.includes('FC03')) {
    options.unshift({ label: '全部导出', value: 1, })
  }
  return <ToolSelect
    displayTextClassName="fill-white-bg"
    style={style}
    onChange={async (val) => {
      if (val === 1) {
        await request.get(`/ins/inspiration/export-all-blog?inspirationId=${inspirationId}`)
        util.track('mn-statement-export', {
          module1: '全部导出',
          module2: '灵感集',
        })
        DownloadCenter.start({ type: 0 })
      } else {
        onChange(val)
      }
    }}
    options={[
      { label: '全部导出', value: 1, },
      { label: '批量导出', value: BATCH_TYPE.export, }
    ]}
    labelIcon="m-daochu"
    label="导出"
  />
}

export const BatchSelect = (props) => {
  const { style, placeholder = '批量操作', onChange, value = '', markStatus, markTimes = 0, permissions } = props
  const _markStatus = markStatus === null ? null : +markStatus
  const _markTimes = markTimes === null ? null : +markTimes
  const batchOption = useMemo(() => {
    const _option = [
      { label: '批量审核', value: BATCH_TYPE.audit, disabled: true }, // 1
      { label: '批量操作', value: BATCH_TYPE.operation }, // 99
    ]
    if (permissions === 3 || permissions === 4) { // 查看者 和 采集者 针对批量审核
      _option[0].disabled = true
    } else if ((_markStatus === 0 || (_markStatus === 3 && _markTimes !== 0))) { // 未提交审核和待审核
      _option[0].disabled = false
    } else if ((permissions === 1 || permissions === 2) && (_markStatus === 2 || _markStatus === 1)) {
      _option[0].disabled = false
    }
    return _option
  }, [_markStatus, _markTimes, permissions])

  // const content = (<div> //ui说先隐藏
  //   <div>新增批量审核功能</div>
  //   <div style={{ color: 'var(--m-text-3)', fontSize: '12px', marginTop: '8px' }}>使用批量审核前,请先选择审核状态</div>
  // </div>)

  return <div style={{ position: 'relative', ...style }}>
    {/* <Guide keyValue="mn:batch:audit" content={content} style={{ right: -80, top: 40, width: 280, height: 132, padding: '24px', ...guideStyle }} /> */}
    <ToolSelect
      displayTextClassName="fill-white-bg"
      value={value}
      onChange={v => onChange(v)}
      options={batchOption}
      placeholder={placeholder}
      labelIcon="m-piliangcaozuo"
      label="批量操作"
    />
  </div>
}
